var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "95vh" }, attrs: { "max-width": "850" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" Uitgebreid zoeken "),
          _c("w-spacer"),
          _c("w-fa", {
            style: { padding: "5px 5px 0" },
            attrs: { icon: "times" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-content",
        { style: { paddingBottom: "0px" } },
        [
          _c(
            "div",
            { style: { position: "relative" } },
            [
              _vm.isSearching
                ? _c("w-fa", {
                    staticClass: "cancel-search",
                    attrs: { icon: "times" },
                    on: {
                      click: function ($event) {
                        return _vm.onCancelSearch()
                      },
                    },
                  })
                : _vm._e(),
              _c("w-input", {
                ref: "search",
                attrs: { autofocus: true, icon: "search" },
                on: {
                  keypress: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchTickets()
                  },
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _c("w-tabs", {
            style: { margin: "5px 0 0 0" },
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.currentTab,
              callback: function ($$v) {
                _vm.currentTab = $$v
              },
              expression: "currentTab",
            },
          }),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { style: { paddingTop: "0px" }, attrs: { tag: "w-card-content" } },
        [
          _vm.currentTab == 0
            ? _c(
                "div",
                _vm._l(_vm.tickets, function (ticket) {
                  return _c(
                    "w-list-item",
                    {
                      key: ticket.id,
                      on: {
                        click: function ($event) {
                          return _vm.openTicket(ticket.id)
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _c(
                          "div",
                          { staticClass: "search-header" },
                          [
                            _c("div", { staticClass: "ticket-title" }, [
                              _vm._v(
                                _vm._s(_vm.getTicketCompanyName(ticket)) +
                                  " - Ticket " +
                                  _vm._s(ticket.id)
                              ),
                            ]),
                            _c("w-spacer"),
                            _vm._v(
                              " " +
                                _vm._s(_vm.timestamp(ticket.timeCreated)) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _c("div", {
                          directives: [
                            {
                              name: "safe-html",
                              rawName: "v-safe-html",
                              value: ticket.subject,
                              expression: "ticket.subject",
                            },
                          ],
                        }),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.currentTab == 1
            ? _c(
                "div",
                _vm._l(_vm.messages, function (message) {
                  return _c(
                    "w-list-item",
                    {
                      key: message.id,
                      on: {
                        click: function ($event) {
                          return _vm.openTicket(message.ticketId)
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _c(
                          "div",
                          { staticClass: "search-header" },
                          [
                            _c("div", { staticClass: "ticket-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getTicketMessageCompanyName(message)
                                ) +
                                  " - Ticket " +
                                  _vm._s(message.ticketId)
                              ),
                            ]),
                            _c("w-spacer"),
                            _vm._v(
                              " " +
                                _vm._s(_vm.timestamp(message.timeCreated)) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _c("div", {
                          directives: [
                            {
                              name: "safe-html",
                              rawName: "v-safe-html",
                              value: message.content,
                              expression: "message.content",
                            },
                          ],
                        }),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.isSearching && _vm.messages.length == 0 && _vm.tickets.length == 0
            ? _c(
                "w-list-item",
                [_c("w-list-item-text", [_vm._v(" Geen tickets gevonden ")])],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }